import React, { type JSX } from 'react';

import { Component as DefaultComponent } from '../../common';

const Component = (props: any): JSX.Element => {
    const normalizedProps =
        props?.widgetData?.primary === undefined
            ? {
                  ...(props ?? {}),
                  widgetData: { ...(props?.widgetData ?? {}), primary: [] },
              }
            : props;

    return <DefaultComponent {...normalizedProps} />;
};
export default Component;
